<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center">
          <v-btn icon="mdi-chevron-left" @click="$router.replace('/cards')" variant="elevated" :density="$vuetify.display.mdAndUp ? 'compact' : 'comfortable' " color="primary"></v-btn>
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Informazioni tessera CONI</h2>
          <h3 class="mx-3" v-else>Informazioni tessera CONI</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>
      <v-col cols="12" v-if="card">
        <ul>
          <li class="body-1"><span class="font-weight-bold">Utente:</span> <a v-if="card.user" :href="'/#/users/'+card.user._id">{{card.user.name}} {{card.user.surname}}</a><span v-else class="font-italic">non registrato</span></li>
          <li class="body-1"><span class="font-weight-bold">Numero tessera:</span> {{card.number}}</li>
          <li class="body-1"><span class="font-weight-bold">Nome:</span> {{card.name}}</li>
          <li class="body-1"><span class="font-weight-bold">Cognome:</span> {{card.surname}}</li>
          <li class="body-1"><span class="font-weight-bold">Codice fiscale:</span> {{card.fiscal_code}}</li>
          <li class="body-1"><span class="font-weight-bold">Assicurazione:</span> {{card.insurance}}</li>
          <li :class="cardExpirationClass(card.expiration)"><span class="font-weight-bold">Scadenza:</span> {{formatDate(card.expiration)}}</li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import {DateTime} from "luxon";
import {inject, onMounted, ref} from "vue";
import type {ConiCard} from '@/models'
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {Messages, Msg} from "@/plugins/messages.ts";
export default {
  name: "CardView",
  setup() {
    const messages = inject('messages') as Messages
    const router = useRouter()
    const route = useRoute()
    const loading = ref<boolean>(false);
    const card = ref<ConiCard|undefined>()

    const loadData = async () => {
      loading.value = true;
      await router.isReady()
      const res = await api.get<ConiCard>('cards', route.params.id as string)
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
      }
      card.value = res.data
      loading.value = false;
    }

    onMounted(async () => {
      await loadData()
    })

    return {
      loading,
      card,
      cardExpirationClass( date:string ) {
        if(utils.toDateTime(date) < DateTime.now()) {
          return "text-error";
        }
        return "text-success";
      },
      formatDate : utils.formatDate,
    };
  }
};
</script>

<style scoped></style>
